import React from 'react';
import styled from 'astroturf/react';

import { isDownloadRead } from '../openerIntent';
import type { ArmSpec } from '../armRegistry';

const NEARLY_FULL_PCT = 85;
const LABEL = 'Getting your PDF, one step left';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xxs-8, 8px);
  margin-bottom: var(--spacing-xs-12, 12px);
`;

const Label = styled.span`
  font-family: var(--type-font-family-sans-serif, 'DM Sans', sans-serif);
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary, #535366);
  text-align: center;
`;

const Track = styled.div`
  width: 100%;
  height: 4px;
  border-radius: var(--border-radius-radius-full, 999px);
  background: var(--stroke-primary, #dddde2);
  overflow: hidden;
`;

const Fill = styled.div`
  height: 100%;
  border-radius: inherit;
  background: var(--primary-brand, #0645b1);
`;

const StepTwoCheckpoint: React.FC = () => (
  <Wrapper>
    <Label>{LABEL}</Label>
    <Track
      role="progressbar"
      aria-label={LABEL}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={NEARLY_FULL_PCT}
    >
      <Fill style={{ width: `${NEARLY_FULL_PCT}%` }} />
    </Track>
  </Wrapper>
);

export const stepTwoSpec: ArmSpec = {
  slots: (ctx) => {
    if (!isDownloadRead(ctx.detail)) return undefined;
    return { aboveHeader: <StepTwoCheckpoint /> };
  },
  stamp: (ctx) => ({
    render_state: isDownloadRead(ctx.detail) ? 'rendered' : 'fallback',
  }),
};
